import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsIdolLocked } from '@/shared/store/slices/idolSlice';
import {
  startIdolOnlineTracker,
  stopIdolOnlineTracker,
  refreshTrackedIdols,
} from '@/shared/utils/idolOnlineTracker';

/**
 * 偶像上線狀態輪詢的開關（見 docs/idol-online-plan.md §4.3），在 App 掛一次，不渲染任何東西。
 *
 * - 已登入、有目前偶像、且目前偶像未被停權鎖定時才輪詢
 * - 換偶像、換 token（例如後台認證重導）時先停再啟：快取作廢、重新查詢（onlineSlice 也會清空結果）
 * - WS 重連（reconnectTick）後立刻刷新一次，補上斷線期間漏掉的狀態變化
 */
function IdolOnlinePoller() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);
  const idolId = useSelector((state) => state.user.idolId);
  const isIdolLocked = useSelector(selectIsIdolLocked);
  const reconnectTick = useSelector((state) => state.app.reconnectTick);
  const isEnabled = Boolean(token && idolId && !isIdolLocked);

  useEffect(() => {
    if (!isEnabled) return;
    startIdolOnlineTracker(dispatch);
    return () => stopIdolOnlineTracker();
  }, [isEnabled, token, idolId, dispatch]);

  // 只在 reconnectTick 跳動時刷新；isEnabled 變化已由上方 start／stop 處理，放進依賴會重複查詢
  useEffect(() => {
    if (reconnectTick > 0 && isEnabled) {
      refreshTrackedIdols();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reconnectTick]);

  return null;
}

export default IdolOnlinePoller;
